module.exports = __webpack_public_path__ + "static/img/img_product_phonehy.cc9b10e.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/产品服务/img_product_phonehy.png
// module id = Eis6
// module chunks = 0